import apiClient from '../http/apiClient';
import publicApiClient from "../http/publicApiClient";

export default class DiscountApiService {
    static list = (params) => apiClient.get('/discount', {params});
    static publicList = (params) => publicApiClient.get('/discount', {params});
    static burn = (hash) => apiClient.put(`/discount/${hash}/burn`);
    static freeze = (hash) => apiClient.put(`/discount/${hash}/freeze`);
    static thaw = (hash) => apiClient.put(`/discount/${hash}/thaw`);
    static trace = (params) => publicApiClient.get('/discount/trace', {}, {params});
}
